import { buySecondSubscription } from '@features/Stripe/api';
import type { TpAddSubscription } from '@features/Stripe/api/buySecondSubscription';
import { useMutation } from '@tanstack/react-query';
import { useGetAppName } from 'src/utils/hooks';

export const useBuySecondSubscription = () => {
  const app = useGetAppName();

  return useMutation({
    mutationFn: (variables: TpAddSubscription) =>
      buySecondSubscription({ ...variables, app }),
    mutationKey: ['modify-subscription'],
  });
};
